import candlestick from './candlestick';

// Heikin-Ashi recurrence -- run once over the whole series (not per-row).
// Legend/tooltip intentionally shows HA values while this mode is active,
// not real OHLC -- matching every trading platform's convention, since HA's
// entire visual language is built on the smoothed values.
export function transformToHeikinAshi(data) {
  const out = [];
  for (let i = 0; i < data.length; i++) {
    const cur = data[i];
    const prevHa = out[i - 1];
    const haClose = (cur.open + cur.high + cur.low + cur.close) / 4;
    const haOpen = prevHa ? (prevHa.open + prevHa.close) / 2 : (cur.open + cur.close) / 2;
    const haHigh = Math.max(cur.high, haOpen, haClose);
    const haLow = Math.min(cur.low, haOpen, haClose);
    out.push({ ...cur, open: haOpen, high: haHigh, low: haLow, close: haClose });
  }
  return out;
}

const heikinAshi = {
  id: 'heikinAshi',
  label: 'Heikin-Ashi',
  transform: transformToHeikinAshi,
  getYExtent: candlestick.getYExtent,
  draw: candlestick.draw,
  tooltipFields: candlestick.tooltipFields,
};

export default heikinAshi;
